import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["title", "aria-label"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.tasks.hasTasks)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(['status-icon', { 'is-active': _ctx.tasks.activeCount > 0, 'is-open': _ctx.tasks.panelOpen }]),
            title: _ctx.title,
            "aria-label": _ctx.title,
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)))
        }, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-tasks" }, null, -1 /* CACHED */)),
            _cache[2] || (_cache[2] = _createTextVNode()),
            (_ctx.badge)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['status-badge', { 'status-badge-danger': _ctx.tasks.problemCount > 0 }])
                }, _toDisplayString(_ctx.badge), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true)
        ], 10 /* CLASS, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true);
}
